/*
 * @Copyright 2023-2025. Institute for Future Intelligence, Inc.
 */

// Selectors over DataStoreState (used with `useDataStore(...)`).
// Holds bulk simulation buffers — energy / speed / position time series.

import { DataStoreState } from '../commonData.ts';

export const energyTimeSeries = (state: DataStoreState) => state.energyTimeSeries;
export const speciesTimeSeries = (state: DataStoreState) => state.speciesTimeSeries;
export const speedArrayMap = (state: DataStoreState) => state.speedArrayMap;
export const positionTimeSeriesMap = (state: DataStoreState) => state.positionTimeSeriesMap;
export const dipoleCurrentBuffer = (state: DataStoreState) => state.dipoleCurrentBuffer;
export const velocityBuffer = (state: DataStoreState) => state.velocityBuffer;
export const positionBuffer = (state: DataStoreState) => state.positionBuffer;
export const measurementTimeSeries = (state: DataStoreState) => state.measurementTimeSeries;
export const pistonTimeSeries = (state: DataStoreState) => state.pistonTimeSeries;
export const speedHistogramSeries = (state: DataStoreState) => state.speedHistogramSeries;
export const temperatureSeries = (state: DataStoreState) => state.temperatureSeries;
